import { useState, useEffect } from 'react';
import HealthOverviewContext from './HealthOverviewContext';
import { SpaceIOService } from 'auth-utils'

import axios from 'axios';


interface Item {
    id: string;
    name: string;
    type: string;
    showInMenu: boolean;
    locations?: Item[];
    healthInfo: object;
}

interface TransformedItem {
    key: string;
    data: {
        liveStatus: boolean;
        name: string;
        Id: string;
        Type: string;
        [key: string]: any; // Allow additional dynamic keys
    };
    children?: TransformedItem[];
}

const HealthOverviewProvider = ({ children }) => {
    const [locationsInfo, setLocationsInfo] = useState(null)
    const [quickInfoData, setQuickInfoData] = useState({})
    const [overallInfo, setOverallInfo] = useState(null);
    // const [listofProducts, setListOfProducts] = useState(null);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [liveTreeAPIData, setLiveTreeAPIData] = useState(null);

    const authKey = localStorage.getItem('spaceio-key');

    function transformLocations(data: Item[]): TransformedItem[] {
        return data.map(item => {
            const transformed: TransformedItem = {
                key: item.id.toString(),
                data: {
                    liveStatus: item.showInMenu ? item.showInMenu : false,
                    name: item.name,
                    Id: item.id,
                    Type: item.type,
                }
            };

            if (item.type === 'FLOOR' && item.healthInfo) {
                transformed.data['Overall'] = item['overallPercentage'];
                transformed.data['ONE'] = item.healthInfo['ONE'];
                transformed.data['FLO'] = item.healthInfo['FLO'];
                transformed.data['BAT-FLO'] = item.healthInfo['BAT-FLO'];
                transformed.data['TIM'] = item.healthInfo['TIM'];
                transformed.data['BAT-TIM'] = item.healthInfo['BAT-TIM'];
                transformed.data['TIM+'] = item.healthInfo['TIM+'];
                transformed.data['BAT-TIM+'] = item.healthInfo['BAT-TIM+'];
                transformed.data['PAM'] = item.healthInfo['PAM'];
                transformed.data['MS'] = item.healthInfo['MS'];

            }

            if (item.locations && item.locations.length > 0) {
                transformed.children = transformLocations(item.locations); // Recursively transform nested locations
            }

            return transformed;
        });
    }

    useEffect(() => {
        const getData = async () => {
            try {
                const data = await fetchAccountLocationData();
                console.log("Data One", data);
                
                const transformedData: TransformedItem[] = transformLocations([data.treeData]);
                setLiveTreeAPIData(transformedData)

                setLocationsInfo(data.floorData)
                setQuickInfoData(data.productLevelDeviceHealth);

                setLoading(false);
            } catch (error) {
                throw (error)
            }
        }
        getData()
    }, [])


    const treeApiData = async () => {

        const init = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `${process.env.PROD_WS_BASE_URL}/api/locations/tree`,
            headers: {
                'authorization': `bearer ${authKey}`,
            }
        };
        try {
            const response = await SpaceIOService.request(`${process.env.PROD_WS_BASE_URL}/api/locations/tree`, init);
            const responseData = await response.json();
            return responseData;
        } catch (error) {
            console.error('An error occurred in the axios request:', error);
        }

    };

    const fetchHealthDataFloorWise = async (arrayOfFloorAssetId: string[]) => {
        if (arrayOfFloorAssetId.length > 0) {
            let data = JSON.stringify(arrayOfFloorAssetId);
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: `${process.env.SPOT_BASE_URL}/assets/data/119/current`,
                headers: {
                    'authorization': `bearer ${authKey}`,
                },
                data: data
            };
            try {
                const response = await axios.request(config);
                // console.log(response.data);
                return response.data;
            } catch (error) {
                console.error('An error occurred in the axios request:', error);
            }
        }
        else { return [] }
    };

    const fetchTOtalDeviceDataFloorWise = async (arrayOfFloorAssetId: string[]) => {
        if (arrayOfFloorAssetId.length > 0) {
            let data = JSON.stringify(arrayOfFloorAssetId);
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: `${process.env.SPOT_BASE_URL}/assets/data/117/current`,  //117 total number of device 
                headers: {
                    'authorization': `bearer ${authKey}`,
                },
                data: data
            };
            try {
                const response = await axios.request(config);
                return response.data;
            } catch (error) {
                console.error('An error occurred in the axios request:', error);
            }
        }
        else { return [] }
    };

    const fetchAccountLocationData = async () => {
        const init = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `${process.env.PROD_WS_BASE_URL}/api/locations?detailed=false`,
            headers: {
                'accept': 'application/json, text/javascript, */*; q=0.01',
            }
        }
        try {
            const treeData = await treeApiData();
            const response = await SpaceIOService.request(`${process.env.PROD_WS_BASE_URL}/api/locations?detailed=false`, init)
            const responseData = await response.json();
            let floorData = [];
            let FloorAssetIds = [];


            await Promise.all(responseData
                .filter(item => item.type === 'FLOOR')
                .map(async (item: any) => {
                    FloorAssetIds.push(item.assetId)
                })
            )


            let productLevelDeviceHealth = {
                ONE: { healthy: 0, total: 0 },
                TIM: { healthy: 0, total: 0 },
                "TIM+": { healthy: 0, total: 0 },
                "BAT-TIM": { healthy: 0, total: 0 },
                "BAT-TIM+": { healthy: 0, total: 0 },
                PAL: { healthy: 0, total: 0 },
                PAM: { healthy: 0, total: 0 },
                FLO: { healthy: 0, total: 0 },
                MS: { healthy: 0, total: 0 },
            };

            const arrayOfHealtyDeviceAcount = await fetchHealthDataFloorWise(FloorAssetIds);
            const arrayOfTotalDeviceAcount = await fetchTOtalDeviceDataFloorWise(FloorAssetIds);

            // console.log(arrayOfHealtyDeviceAcount);
            // console.log(arrayOfTotalDeviceAcount);


            await Promise.all(responseData
                .filter(item => item.type === 'FLOOR')
                .map(async (item: any) => {
                    floorData.push(item)
                })
            )

            // Function to merge health data into raw data if conditions are met
            floorData.forEach(rawItem => {
                const healthItem = arrayOfHealtyDeviceAcount.find(health => health.id === rawItem.assetId && health.hasOwnProperty('utcEpoch'));
                const deviceTotalCountItem = arrayOfTotalDeviceAcount.find(deviceTotalCount => deviceTotalCount.id === rawItem.assetId && deviceTotalCount.hasOwnProperty('utcEpoch'));

                if (healthItem && deviceTotalCountItem) {

                    let overallValueHelath = Object.keys(healthItem).reduce((sum, key) => {
                        if (key !== "utcEpoch"
                            && key !== "tzEpoch"
                            && key !== 'processedAt'
                            && key !== 'id'
                        ) {
                            return sum + healthItem[key];
                        }
                        return sum;
                    }, 0);

                    let overallValueTotal = Object.keys(deviceTotalCountItem).reduce((sum, key) => {
                        if (key !== "utcEpoch"
                            && key !== "tzEpoch"
                            && key !== 'processedAt'
                            && key !== 'id'
                        ) {
                            return sum + deviceTotalCountItem[key];
                        }
                        return sum;
                    }, 0);

                    let overallPercentage = parseFloat(((overallValueHelath / overallValueTotal) * 100).toFixed(2));

                    rawItem.healthData = healthItem;
                    rawItem.totalDeviceCount = deviceTotalCountItem;
                    rawItem.overallPercentage = overallPercentage;
                }
            });



            // console.log(floorData);


            const arrangeData = (data: any[]): void => {
                data.forEach((item) => {
                    switch (item.type) {
                        case "REGION":
                            // console.log("   ", item)
                            break;
                        case "LOCATION":
                            // console.log("       ", item)
                            break;
                        case "BUILDING":
                            // console.log("           ", item)
                            break;
                        case "FLOOR":
                            const maininfo = floorData.find(floorInfo => floorInfo.id === item.id);
                            item.healthInfo = maininfo.healthData ? maininfo.healthData : null;
                            item.totalDeviceCount = maininfo.totalDeviceCount ? maininfo.totalDeviceCount : null;
                            item.overallPercentage = maininfo.overallPercentage ? maininfo.overallPercentage : null;

                            // console.log("               ", maininfo)
                            break;
                        default:
                            break;
                    }

                    // Recursively handle nested locations
                    if (item.locations) {
                        arrangeData(item.locations);
                    }
                });
            };

            arrangeData(treeData.locations);

            // treeData.locations.map((region) => {
            //     console.log("Region", region);
            //     region.locations.map((location) => {
            //         console.log("   location", location);
            //     })
            // });



            let floorLevelDeviceHealth = {
                ONE: 0,
                TIM: 0,
                "TIM+": 0,
                "BAT-TIM": 0,
                "BAT-TIM+": 0,
                PAL: 0,
                PAM: 0,
                FLO: 0,
                MS:0,
                overall: 0
            }

            let floorLevelTotalDevices = {
                ONE: 0,
                TIM: 0,
                "TIM+": 0,
                "BAT-TIM": 0,
                "BAT-TIM+": 0,
                PAL: 0,
                PAM: 0,
                FLO: 0,
                MS:0,
                overall: 0
            };

            let floorLevelDeviceHealthPercentage = {
                ONE: 0,
                TIM: 0,
                "TIM+": 0,
                "BAT-TIM": 0,
                "BAT-TIM+": 0,
                PAL: 0,
                PAM: 0,
                FLO: 0,
                MS:0,
                overall: 0
            }


            arrayOfHealtyDeviceAcount.forEach((floorWiseHealthDevice: any) => {
                Object.keys(floorWiseHealthDevice).forEach(key => {
                    if (floorLevelTotalDevices.hasOwnProperty(key) && floorWiseHealthDevice.hasOwnProperty(key)) {
                        floorLevelDeviceHealth[key] += floorWiseHealthDevice[key];
                    }
                });
            });

            arrayOfTotalDeviceAcount.forEach((floorWiseTotalDevice: any) => {
                Object.keys(floorWiseTotalDevice).forEach(key => {
                    if (floorLevelTotalDevices.hasOwnProperty(key) && floorWiseTotalDevice.hasOwnProperty(key) && floorWiseTotalDevice[key] !== 0) {
                        floorLevelTotalDevices[key] += floorWiseTotalDevice[key];
                    }
                });
            });

            // console.log(floorLevelDeviceHealth);
            // console.log(floorLevelTotalDevices);


            // Calculate percentage health for each device type
            Object.keys(floorLevelDeviceHealthPercentage).forEach(key => {
                if (key !== 'overall' && floorLevelTotalDevices[key] > 0) {
                    floorLevelDeviceHealthPercentage[key] = parseFloat(((floorLevelDeviceHealth[key] / floorLevelTotalDevices[key]) * 100).toFixed(2));
                }
                else {
                    floorLevelDeviceHealthPercentage[key] = null;
                }
            });


            let overallHealthyDevices = Object.entries(floorLevelDeviceHealth).reduce((acc, [key, val]) => {
                // Exclude 'ONE' product from accumulation
                if (typeof val === 'number') {
                    return acc + val;
                }
                return acc;
            }, 0);

            let overallTotalDevices = Object.entries(floorLevelTotalDevices).reduce((acc, [key, val]) => {
                // Exclude 'ONE' product from accumulation
                if (typeof val === 'number') {
                    return acc + val;
                }
                return acc;
            }, 0);

            if (overallTotalDevices > 0) {
                floorLevelDeviceHealthPercentage.overall = parseFloat(((overallHealthyDevices / overallTotalDevices) * 100).toFixed(2));
                setOverallInfo(floorLevelDeviceHealthPercentage.overall)
            } else {
                floorLevelDeviceHealthPercentage.overall = null
                setOverallInfo(floorLevelDeviceHealthPercentage.overall)
            }

            // Accumulate health and total devices for each product
            Object.keys(productLevelDeviceHealth).forEach(key => {
                productLevelDeviceHealth[key].healthy += floorLevelDeviceHealth[key];
                productLevelDeviceHealth[key].total += floorLevelTotalDevices[key];
            });

            // console.log(productLevelDeviceHealth);
            // console.log(floorData);
            // console.log(treeData);

            return {
                productLevelDeviceHealth,
                floorData,
                treeData
            }

        }
        catch (e) {
            setError(error);
            setLoading(false);
        }
    }

    if (loading) {
        return (
            <div style={{ height: '100vh', width: '100%', textAlign: 'center' }}>
                Loading...
            </div>
        );
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <HealthOverviewContext.Provider value={{
            locationsInfo: locationsInfo,
            quickInfoData: quickInfoData,
            overallInfo: overallInfo,
            liveTreeAPIData: liveTreeAPIData,
            // listofProducts: listofProducts
        }}>
            {children}
        </HealthOverviewContext.Provider >
    );
}

// Skip prop validation by setting propTypes to null
HealthOverviewProvider.propTypes = null;

export default HealthOverviewProvider;